/**
 * Occasion checkbox list — uses the fixed OCCASIONS array from utils.
 *
 * Extracted from `app/(main)/products/ProductsClient.tsx` lines 1398–1413.
 */

"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { OCCASIONS } from "../product-card-utils";
import { FilterSection } from "./FilterSection";

interface OccasionSectionProps {
  selected: string[];
  onToggle: (o: string) => void;
  isOpen: boolean;
  onToggleSection: (title: string) => void;
}

export function OccasionSection({
  selected,
  onToggle,
  isOpen,
  onToggleSection,
}: OccasionSectionProps) {
  return (
    <FilterSection
      title="Occasion"
      count={selected.length}
      isOpen={isOpen}
      onToggle={onToggleSection}
    >
      <div className="flex flex-col gap-2">
        {OCCASIONS.map((o) => (
          <label
            key={o}
            className="flex cursor-pointer items-center gap-3 py-1 text-sm text-foreground"
          >
            <Checkbox
              checked={selected.includes(o)}
              onCheckedChange={() => onToggle(o)}
            />
            <span>{o}</span>
          </label>
        ))}
      </div>
    </FilterSection>
  );
}
